import { BetSlipState, BetSlipType } from '@/interface/enum';

export interface IBetSlipView {
    betSlipType: BetSlipType;
    betSlipState: BetSlipState;
}

const legacySingleBetSlipTypes = Object.freeze([
    BetSlipType.Single,
    BetSlipType.Dynamic,
    BetSlipType.Outright,
]);

function isBetSlipType(value: string): value is BetSlipType {
    return Object.values<string>(BetSlipType).includes(value);
}

function isBetSlipState(value: string): value is BetSlipState {
    return Object.values<string>(BetSlipState).includes(value);
}

function toBetSlipType(storedValue: string | null): BetSlipType {
    return storedValue !== null && isBetSlipType(storedValue)
        ? storedValue
        : BetSlipType.None;
}

function toBetSlipState(storedValue: string | null): BetSlipState {
    return storedValue !== null && isBetSlipState(storedValue)
        ? storedValue
        : BetSlipState.Closed;
}

export function resolveBetSlipRestoreView(
    isSingleModeEnabled: boolean,
    storedBetSlipType: string | null,
    storedBetSlipState: string | null,
): IBetSlipView {
    const betSlipType = toBetSlipType(storedBetSlipType);
    const isIncompatibleType = betSlipType === BetSlipType.None
        || (isSingleModeEnabled
            ? legacySingleBetSlipTypes.includes(betSlipType)
            : betSlipType === BetSlipType.SingleMode);

    if (isIncompatibleType) {
        return {
            betSlipType: BetSlipType.None,
            betSlipState: BetSlipState.Closed,
        };
    }

    return {
        betSlipType,
        betSlipState: toBetSlipState(storedBetSlipState),
    };
}
